/**
 * import react
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * import material-ui
 */
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';

/**
 * import ui helper
 */
import { getCameraExtendedInfo, getCameraNvrRtspPref, getCameraAIRtspPref } from './helper';

const InfoDialog = (props = {}) => {
  const [nvrSel, setNvrSel] = useState(getCameraNvrRtspPref(props.slot));
  const [aiSel, setAiSel] = useState(getCameraAIRtspPref(props.slot));
  const { contentList = [], profiles = [] } = getCameraExtendedInfo(props.slot, nvrSel, aiSel);
  const getContentKeyList = () => {
    return (
      <List>
        {contentList.map(({ key }, idx) => {
          return (
            <ListItem key={idx}>
              <ListItemText>{key}</ListItemText>
            </ListItem>
          );
        })}
      </List>
    );
  };
  const getContentValList = () => {
    return (
      <List>
        {contentList.map(({ val }, idx) => {
          return (
            <ListItem key={idx}>
              <ListItemText>{val ? `: ${val}` : ': -'}</ListItemText>
            </ListItem>
          );
        })}
      </List>
    );
  };
  const getRtspList = () => {
    if (profiles.length === 0) {
      return null;
    } else {
      return (
        <Table size='small'>
          <TableHead>
            <TableRow>
              {
                ['S.No', 'Rtsp', 'Width', 'Height', 'Codec', 'FPS', 'EWC/LVM/AI', 'NVR'].map((item) => {
                  return (
                    <TableCell key={item} align='center'>{item}</TableCell>
                  );
                })
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {profiles.map(({ profileName = '', rtspUrl = '', codec = '', width = '', height = '', fps = '', disabled = false }, idx) => {
              return (
                <TableRow key={idx} hover>
                  <TableCell align='center'>{`#${idx + 1}`}</TableCell>
                  <TableCell align='center'>
                    <List>
                      {
                        [rtspUrl, profileName].map((item, idx) => {
                          return (
                            <ListItem key={idx} style={{ paddingTop: 0, paddingBottom: 0, textAlign: 'center'}}>
                              <ListItemText>{item}</ListItemText>
                            </ListItem>
                          );
                        })
                      }
                    </List>
                  </TableCell>
                  {
                    [width, height, codec, fps].map((item, idx) => {
                      return (
                        <TableCell key={idx} align='center'>{item || '-'}</TableCell>
                      );
                    })
                  }
                  <TableCell align='center'>
                    <Checkbox checked={aiSel === profileName} disabled={disabled} onClick={() => setAiSel(profileName)} />
                  </TableCell>                  
                  <TableCell align='center'>
                    <Checkbox checked={nvrSel === profileName} disabled={disabled} onClick={() => setNvrSel(profileName)} />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      );
    }
  };
  const getContent = () => {
    return (
      <Grid container>
        <Grid item xs={12}>
          <Grid container>
            <Grid item>
              {getContentKeyList()}
            </Grid>
            <Grid item>
              {getContentValList()}
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          {getRtspList()}
        </Grid>
      </Grid>
    );
  };

  return (
    <Dialog open={true} maxWidth="lg">
      <DialogTitle>Camera Info</DialogTitle>
      <DialogContent>
        {getContent()}
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={() => { props.handleClose([nvrSel, aiSel]); }}>Close</Button>
      </DialogActions>
    </Dialog>
  );

};

InfoDialog.propTypes = {
  slot: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired
};
 
export default InfoDialog;